var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { BaseService } from "app/views/base.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { DataProvider2 } from "../../provider/data2.provider";
var AccessorService = /** @class */ (function (_super) {
    __extends(AccessorService, _super);
    function AccessorService(http, filter, dp) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.filter = filter;
        _this.dp = dp;
        return _this;
    }
    AccessorService.prototype.getIframeInfo = function () {
        return this.dp.get('/accessor2/iframe', this.filter.filterParams);
    };
    AccessorService.prototype.getMainInfo = function (queryParams) {
        return this.dp.get('/accessor2/main', queryParams);
    };
    AccessorService.prototype.getStats = function (queryParams) {
        return this.dp.get('/accessor2/stats', queryParams);
    };
    AccessorService.prototype.getMyStats = function (queryParams) {
        return this.dp.get('/accessor2/mystats', queryParams);
    };
    AccessorService.prototype.getPersonalStats = function (queryParams) {
        return this.dp.get('/accessor2/personal_stats', queryParams);
    };
    AccessorService.prototype.setCategory = function (data) {
        return this.dp.get('/accessor2/set', data);
    };
    AccessorService.prototype.checkSite = function (data) {
        return this.dp.get('/accessor2/check', data);
    };
    AccessorService.prototype.updateSite = function (data) {
        return this.dp.get('/accessor2/update', data);
    };
    AccessorService.prototype.getConfig = function () {
        return this.dp.get('/accessor2/manage');
    };
    AccessorService.prototype.saveConfig = function (data) {
        return this.dp.get('/accessor2/dump_params', data);
    };
    AccessorService.prototype.getSiteDetails = function (queryParams) {
        return this.dp.get('/accessor2/site_details', queryParams);
    };
    return AccessorService;
}(BaseService));
export { AccessorService };
